export default {
  host: process.env.VUE_APP_HOST,
  api: process.env.VUE_APP_HOST + '/interface',
  version: process.env.VUE_APP_VERSION,
  check_auth: process.env.VUE_APP_CHECK_AUTH,
  project_title: process.env.VUE_APP_PROJECT_TITLE,
  contact_way: process.env.VUE_APP_CONTACT_WAY,
  copyright: process.env.VUE_APP_COPYRIGHT,
  company: process.env.VUE_APP_COMPANY
}

// VUE_APP_NODE_ENV=production
// VUE_APP_VERSION=2.0.1
// VUE_APP_CHECK_AUTH=true
// VUE_APP_HOST=https://student.hgnet.tech
// VUE_APP_PROJECT_TITLE=HGVACATE
// VUE_APP_CONTACT_WAY=@
// VUE_APP_COMPANY=淄博和光网络科技有限公司
// VUE_APP_COPYRIGHT=Copyright © 2024 - 2025 HGVACATE. All Rights Reserved.